import React from 'react';
import PropTypes from 'prop-types';

const DuplicateIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '20px';
  const h = (height) ? height.toString().concat('px') : '24px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 20 24"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M3.77214 0.969727C3.6032 0.969727 3.44229 1.042 3.32985 1.16837L0.150293 4.74216C0.0534931 4.85096 0 4.99164 0 5.13742V14.06C0 14.388 0.265309 14.6539 0.592584 14.6539H5.19572C5.52299 14.6539 5.7883 14.388 5.7883 14.06C5.7883 13.732 5.52299 13.4661 5.19572 13.4661H1.18517V5.73132H11.4464V7.6288C11.4464 7.9568 11.7117 8.2227 12.039 8.2227C12.3663 8.2227 12.6316 7.9568 12.6316 7.6288V5.13742C12.6316 4.99164 12.5781 4.85096 12.4813 4.74216L9.30173 1.16837C9.18929 1.042 9.02838 0.969727 8.85944 0.969727H3.77214ZM5.72321 4.54351H1.91492L4.0377 2.15754H5.72321V4.54351ZM6.90837 4.54351V2.15754H8.59388L10.7167 4.54351H6.90837ZM10.6983 9.58946C10.8107 9.46308 10.9716 9.39081 11.1406 9.39081H16.2278C16.3968 9.39081 16.5577 9.46308 16.6701 9.58946L19.7437 13.0441C19.8966 13.1297 20 13.2932 20 13.4808V22.575C20 22.8512 19.7761 23.075 19.5 23.075H7.86842C7.59228 23.075 7.36842 22.8512 7.36842 22.575V22.4851L7.36841 22.4811V13.5585L7.36842 13.5546V13.4808C7.36842 13.2932 7.47176 13.1297 7.62463 13.0442L10.6983 9.58946ZM12.5641 21.8872C12.6375 21.8872 12.7078 21.9006 12.7727 21.925H18.85V16.2519C18.8272 16.1889 18.8148 16.1208 18.8148 16.0499V14.1524H8.55358V21.8872H12.5641ZM9.28333 12.9646H13.0916V10.5786H11.4061L9.28333 12.9646ZM14.2768 10.5786V12.9646H18.0851L15.9623 10.5786H14.2768Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

DuplicateIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default DuplicateIcon;
